<template>
    <div class="col-sm-12 d-flex flex-wrap py-3">

        <div class="col-sm-6 d-flex flex-column h-100">
            <client-form class="flexGrow1" :disabled="disabled" :customer="reservation.customer" :bookingComponents="reservation.bookingComponents" :transport="reservation.transport" :reservation="reservation"></client-form>

            <!-- <div class="col-sm-12 border-light radius-normal mt-2 d-flex align-items-center p-2 d-flex justify-content-between">
                <div class="d-flex align-items-center">
                    <i class="ico ico-ticket color-6 fs-larger"></i>
                    <span class="font-weight-600 darker">Voucher code</span>
                </div>
                <div class="w-50 d-flex justify-content-end">
                    <input type="text" class="w-100 px-2 py-1 text-center bg-lighter" v-model="reservation.bookingOperatorCode" :disabled="isReservationReadOnly">
                </div>
            </div> -->

        </div>

        <div class="col-sm-6">
            <div class="row">
                <div class="col-sm-12">
                    <div class="col-sm-12 border-light radius-normal">
                        <checkins :disabled="disabled" :reservation="reservation"></checkins>
                    </div>
                </div>

                <div class="col-sm-12 mt-2">


                    <div class="col-sm-12 border-light radius-normal">
                        <price-total :disabled="disabled" :reservation="reservation"></price-total>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
import { reservationsMixin } from '@/mixins/reservations'
import CustomerDetails from '@/components/reservations/NewReservation/Resume/Details/CustomerDetails'
import ClientForm from './TabDetails/ClientForm'
import Checkins from './TabDetails/Checkins'
import PriceTotal from './TabDetails/PriceTotal'

export default {
    data: function() {
        return {

        }
    },
    props:{
        reservation:{
            type: Object
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    components: {
        CustomerDetails,
        ClientForm,
        Checkins,
        PriceTotal
    },
    mixins: [
        reservationsMixin
    ]
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// TabDetails.vue?7f655a98